import React from "react";
import { View, StyleSheet } from "react-native";
import CustomSearchInput from "../../../components/common/general/CustomSearchInput/CustomSearchInput";
import SortingDropdown from "../../../components/common/TableControls/SortingDropdown/SortingDropdown";

interface AdminTableHeaderProps {
  searchQuery?: string;
  setSearchQuery?: (query: string) => void;
  sortBy: string;
  setSortBy: (sortBy: string) => void;
  sortDropdownOpen: boolean;
  setSortDropdownOpen: (open: boolean) => void;
  sortItems: { label: string; value: string }[];
  placeholder?: string;
}

const AdminTableHeader: React.FC<AdminTableHeaderProps> = ({
  searchQuery,
  setSearchQuery,
  sortBy,
  setSortBy,
  sortDropdownOpen,
  setSortDropdownOpen,
  sortItems,
  placeholder = "Search by any value",
}) => {
  return (
    <View style={styles.container}>
      <View style={styles.controlsRow}>
        <View style={styles.sortContainer}>
          <SortingDropdown
            sortBy={sortBy}
            setSortBy={setSortBy}
            sortDropdownOpen={sortDropdownOpen}
            setSortDropdownOpen={setSortDropdownOpen}
            sortItems={sortItems}
            label="Sort by"
          />
        </View>
        {searchQuery !== undefined && setSearchQuery && (
          <View style={styles.searchContainer}>
            <CustomSearchInput placeholder={placeholder} searchQuery={searchQuery} setSearchQuery={setSearchQuery} />
          </View>
        )}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    padding: 24,
    backgroundColor: "#F9FAFB",
    borderBottomWidth: 1,
    borderBottomColor: "#E5E7EB",
    zIndex: 5000,
    elevation: 5000,
  },
  controlsRow: {
    flexDirection: "row",
    gap: 16,
    alignItems: "center",
    zIndex: 5001,
    justifyContent: "space-between",
  },
  sortContainer: {
    zIndex: 5002,
    elevation: 5002,
  },
  searchContainer: {
    flex: 1,
    maxWidth: 400,
    alignItems: "flex-end",
  },
});

export default AdminTableHeader;
